<template>
    <div class="py-9 flex flex-col">
        <h3 class="text-lg font-black tracking-wider px-9">{{ heading }}</h3>
        <div class="max-h-[350px] overflow-y-auto px-9 space-y-1 mt-3">
            <div
                class="flex gap-3 items-center"
                v-for="(option, key) in options"
                :key="key"
            >
                <input
                    type="checkbox"
                    :id="index + key"
                    :checked="filterInUse(option)"
                    :value="true"
                    :disabled="optionDisabled(option)"
                    @click="toggleFilter(option)"
                    class="peer cursor-pointer disabled:cursor-auto"
                />
                <label :for="index + key" class="text-black peer-disabled:text-xp-medium-grey text-lg font-normal">
                    {{option.min}} {{separator}} {{option.max + option.unit}}
                </label>
            </div>
        </div>
        <div class="px-9 pt-7 mt-auto flex justify-end">
            <button
                type="button"
                class="text-sm tracking-[2.51px] font-black uppercase underline underline-offset-4 decoration-2 decoration-xp-lilac hover:decoration-xp-electron-green"
                v-on:click="filterReset"
            >
                Reset
            </button>
        </div>
    </div>
</template>

<script>
import Filter from '../../../../../mixins/filters/Filter'

export default {
    name: 'ProductRangeFilter',
    mixins: [Filter],
    props: {
        separator: {
            type: String,
            default: '-'
        }
    }
}
</script>
